import React from 'react';
export const AllInclusive = ({ title, ...rest }) => (
  <svg viewBox="0 0 500 500" {...rest}>
    {title && <title>{title}</title>}
    <path d="M157.3 294.8c.8-1.2 81.1-121.5 184.3-206.6l4.8-4-37-44.2-4.7 3.9c-66.6 54.8-114.7 109-145 147.1l-25.9-51.7-51.9 25.5 69.5 139 5.9-9z" />
    <path d="M415.9 233.8c-32.6-1.1-214.5 80.7-229.5 90.6-11.6 7.8-3.4 29.9 11.4 35.7 47.7 18.4 89.9-46.8 146.2-10.2-31.8 3-174.2 106.6-191-11.6-95.2-39.9-133.5-65.7-148.4-36.9-14.4 27.6 3.2 27.4 152.7 127.8 19.8 13.3 42.8 28.2 59.6 30.2 66.8 8 183.2-78.6 251.1-73.2 11 .9 21.5 2.7 31.5 5.1V255.1c-30.4-11.1-61.4-20.5-83.6-21.3z" />
  </svg>
);
